module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content pd-025"
  }, [_c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("结算信息")]), _vm._v(" "), _c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.showPop = true
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("开户银行 ")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.bankName ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.bankName || '请选择开户银行'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("账号名称")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入账号名称"
    },
    model: {
      value: (_vm.formItem.bankUname),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankUname", $$v)
      },
      expression: "formItem.bankUname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("银行账户")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "digit",
      "clearable": true,
      "placeholder": "请输入银行账户"
    },
    model: {
      value: (_vm.formItem.bankNo),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankNo", $$v)
      },
      expression: "formItem.bankNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("开户行地址")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入开户行地址"
    },
    model: {
      value: (_vm.formItem.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankAddress", $$v)
      },
      expression: "formItem.bankAddress"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("资质信息")]), _vm._v(" "), _c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot"
  }, [_vm._m(1), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入营业执照单位名称"
    },
    model: {
      value: (_vm.formItem.licenseName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "licenseName", $$v)
      },
      expression: "formItem.licenseName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("营业执照号")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入营业执照号"
    },
    model: {
      value: (_vm.formItem.licenseNo),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "licenseNo", $$v)
      },
      expression: "formItem.licenseNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("法人姓名")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入法人姓名"
    },
    model: {
      value: (_vm.formItem.identityName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "identityName", $$v)
      },
      expression: "formItem.identityName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_vm._m(2), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入法人身份证号"
    },
    model: {
      value: (_vm.formItem.identityCard),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "identityCard", $$v)
      },
      expression: "formItem.identityCard"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入注册地址"
    },
    model: {
      value: (_vm.formItem.regAddress),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "regAddress", $$v)
      },
      expression: "formItem.regAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("上传清晰营业执照")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.licensePicView),
      expression: "formItem.licensePicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.licensePicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('licensePicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.licensePicView),
      expression: "!formItem.licensePicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadLicense
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: " fs-32 color-333"
  }, [_vm._v("上传其他清晰证件")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.otherPicView),
      expression: "formItem.otherPicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.otherPicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('otherPicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.otherPicView),
      expression: "!formItem.otherPicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadOther
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("下一步")])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.dicts['bank_code'],
      "value-key": "codename"
    },
    on: {
      "cancel": function($event) {
        _vm.showPop = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-register-state"
  }, [_c('div', {
    staticClass: "text color-999"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinlv color-999"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-main"
  }, [_vm._v("公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinhei color-main"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-999"
  }, [_vm._v("店铺设置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("营业执照"), _c('br'), _vm._v("单位名称")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("法人"), _c('br'), _vm._v("身份证号")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b2f962","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/companyInfo.vue
// module id = X3yz
// module chunks = 51